import { render } from "./Catalog_Dialog.vue?vue&type=template&id=40929672&ts=true"
import script from "./Catalog_Dialog.vue?vue&type=script&lang=ts"
export * from "./Catalog_Dialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__